import type { SVGProps } from "react";

/** A solid brand-red location marker with a transparent center cutout. */
export function LocationPin(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...props}>
      <path
        fill="#e0313e"
        fillRule="evenodd"
        d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 10.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
